export const iconFontAwesomeTimeHourglassStart = (
	<i className="fa-solid fa-hourglass-start"></i>
);
